import { Injectable } from "@angular/core"
import  { CanActivate, Router } from "@angular/router"
import  { AuthService } from "../services/auth.service"

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      return true
    }

    console.log("Auth guard: User not authenticated, redirecting to login")
    this.router.navigate(["/login"])
    return false
  }
}
